<template>
    <component :is="wrapperComponent" :title="title">
        <template #button-open="{ openDrawer }">
            <slot name="button-open" :openDrawer="openDrawer">                
                <el-button @click="openDrawer()">
                    Open
                </el-button>
            </slot>
        </template>
         <template #header>
            <slot name="header">
                <strong>{{ title }}</strong>
            </slot>
        </template>
        <slot />
    </component>
</template>

<script>
import DesktopWrapper from '@/components/DesktopWrapper.vue'
import MobileDrawer from '@/components/MobileDrawer.vue'
export default {
    components: {
        DesktopWrapper,
        MobileDrawer
    },
    props: {
        title: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data(){
        return {
            isMobile: false,
        }
    },
    mounted() {
        this.checkDevice()
        window.addEventListener('resize', this.checkDevice)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkDevice)
    },
    computed: {
        wrapperComponent() {
            return this.isMobile ? 'MobileDrawer' : 'DesktopWrapper'
        }
    },
    methods: {
        checkDevice() {
            // mobile + ipad
            this.isMobile = window.innerWidth <= 1024
        }
    },
}
</script>